"use strict";
window.up.compiler('.js-alert_if_active_subscription_guests', function (el) {
    const element = el;
    function preventWhenGuests(e) {
        const activeGuestsCountString = element.dataset.activeGuestsCount;
        if (activeGuestsCountString) {
            const activeGuestsCount = parseInt(activeGuestsCountString, 10);
            const activeGuestsAlert = element.dataset.activeGuestsAlert;
            if (!element.checked && activeGuestsCount > 0) {
                alert(activeGuestsAlert);
                e.preventDefault();
                return false;
            }
        }
    }
    element.addEventListener('click', preventWhenGuests);
});
function hideOrShowSection(input) {
    var _a;
    const section = (_a = input
        .closest('.js-checkbox_with_hidden_content')) === null || _a === void 0 ? void 0 : _a.querySelector('.js-checkbox_with_hidden_content__hidden_content');
    if (section) {
        if (input.checked) {
            section.style.display = 'block';
        }
        else {
            section.style.display = 'none';
        }
    }
}
window.up.compiler('.js-checkbox_with_hidden_content', function (element) {
    const input = element.querySelector('.js-checkbox_with_hidden_content__switch');
    if (input) {
        hideOrShowSection(input);
        input.addEventListener('change', function () {
            hideOrShowSection(input);
        });
    }
});
